module.exports = __webpack_public_path__ + "static/img/Globo de texto Utopie.bd6517d7.svg";